<style lang="stylus">
    .fileview-star
        display flex
        flex-direction column
        position relative
        height 100%
        user-select none
        .files-title
            height 40px
            display flex
            justify-content space-between
            align-items center
            padding-right 60px
            white-space nowrap
            pointer-events none
            .files-path
                position absolute
                color #000
                font-size 18px
                display flex
                top 0

                div
                    margin-right 4px
                    max-width 200px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    cursor pointer
                    pointer-events auto
            .back
                margin-top 80px
        .searchMarginT
            margin-top 40px
        .files-right
            @media screen and (max-width: 1200px)
                display none
        .files-search-box
            input
                &:focus
                    border-color var(--themeColor)
                    box-shadow unset


    .ivu-dropdown
        .ivu-dropdown-rel
            a:focus,a:hover
                color var(--themeColor)!important
    .files-order-box
        &:hover,&:focus
            border-color var(--themeColor)!important
            box-shadow unset!important
</style>

<template>
    <div class="fileview-star" @click="clear()" v-click-outside="clear">
        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="menuList"
            @handleClicks="handleClick($event)"
        />

        <Searchback v-if="searchMode" :str="lastSearch" :num="activeList.length" @searchBack="searchBack" />

        <div v-if="layoutMode == 'list' && !searchMode && !noDataStatus" class="fileview-list-header fileview-list-header-star">
            <div class="file-name">
                <span>{{ $t("name") }}</span>
            </div>
            <div class="file-time">
                <span>{{ $t("time") }}</span>
            </div>
            <div class="file-size">
                <span>{{ $t("size") }}</span>
            </div>
            <div class="file-select"></div>
        </div>
        <div class="fileview-scroll" @click="clearFile" @scroll="scrollStarEvent" ref="filesScroll">
            <div class="emptyCloud limit-position" v-cloak v-if="emptyStatus">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>
            <template v-if="layoutMode == 'grid'">
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in activeList"
                        :key="searchMode ? `search-${searchValue}-${index}` : '' + index"
                        :type="'star'"
                        :mode="searchMode ? 'search' : 'files'"
                        :index="index"
                        :file="item"
                        :searchKey="searchValue"
                        @setStarFile="setStarFile"
                    />
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div class="files-box-list" ref="filesBoxList">
                        <listFile
                            v-for="(item, index) in activeList"
                            :key="searchMode ? `search-${searchValue}-${index}` : '' + index"
                            :type="'star'"
                            :mode="searchMode ? 'search' : 'files'"
                            :index="index"
                            :file="item"
                            :searchKey="searchValue"
                            @setStarFile="setStarFile"
                        />
                    </div>
                </div>
            </template>
            <div ref="scrollblock"></div>
        </div>
    </div>
</template>

<script lang="ts">
    // 原星标文件tab
    import naturalsort from "javascript-natural-sort";

    naturalsort.insensitive = true;
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "../fileItem";
    import listFile from "./listFile.vue";
    import RightMenu from "../RightMenu.vue";
    import gridFile from "./gridFile.vue";
    import Searchback from "./parts/searchback.vue";

    @Component({
        components: {
            fileItem,
            listFile,
            gridFile,
            RightMenu,
            Searchback,
        },
    })
    export default class WbStar extends Mixins(fileItem) {
        filesList = [];
        searchList = [];
        searchValue = "";
        deleteRecordBlock = false;
        loadingStatus = true;
        isAdding = false;
        pageInfo = {
            offset: 0,
            count: 20,
            total: 0,
            end: false,
        };

        get emptyStatus() {
            return this.userInfo && this.filesList && this.filesList.length == 0 && !this.loadingStatus;
        }
        get noDataStatus() {
            return this.filesList.length == 0;
        }
        get searchMode() {
            return this.$store.state.star.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setStarStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }

        //  多语言要写在 computed 中
        get menuList() {
            return [
                { label: this.$t("openFile"), ban: this.fileSelected.length > 1 },
                { label: this.$t("cancelStar"), ban: this.selectFilesIndex.length != 1 },
            ];
        }
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get activeList() {
            return this.searchMode ? this.searchList : this.filesList;
        }

        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.fileSelected.length == 1 &&
                            this.openFiles(this.searchValue ? this.searchList[this.fileSelected[0]] : this.filesList[this.fileSelected[0]]);
                    },
                ],
                [
                    1,
                    () => {
                        this.selectFilesIndex.length == 1 && this.setStarFile();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }
        get selFiles() {
            let list = this.activeList;
            return list.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }

        orderName = "time";
        rotate = 0;
        setOrder(name) {
            this.orderName = name;
            if (name === "time") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            } else if (name === "size") {
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                } else {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size).reverse();
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                } else {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            }
        }
        order() {
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(b.name, a.name));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else if (this.orderName == "size") {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.filesList = this.filesList.sort((a, b) => naturalsort(a.name, b.name));
                } else if (this.orderName == "time") {
                    this.filesList = this.filesList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                } else if (this.orderName == "size") {
                    this.filesList = this.filesList.sort((a, b) => a.size - b.size).reverse();
                }
            }
        }

        receiveMessage(event) {
            if (event.origin !== location.origin) return;
            if (event.data.type && event.data.type == "updateMyfile") {
                // 更新最近浏览文件
                if (event.data.updateStarFile) {
                    this.getStarList();
                }
            }
        }

        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
        }
        clearFile() {
            this.selectFilesIndex = [];
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }
        setLayout() {
            this.$store.commit("changeLayout");
            this.clearFile();
        }
        lastSearch = "";
        search() {
            if (this.searchValue) {
                this.lastSearch = this.searchValue;
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    if (item.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
                        let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        item.filePath = filePath;
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        created() {
            this.$bus.$on("refreshStar", () => {
                this.getStarList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getStarList();
            } else {
                this.$bus.$on("loginSucc-star", () => {
                    this.getStarList();
                });
            }
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        scrollStarEvent() {
            this.clear();
            // this.scrollGetData();
        }
        // scrollGetData() {
        //     //处理滚动到底部后继续加载图片
        //     let con = <HTMLElement>this.$refs.filesScroll;
        //     con.addEventListener("scroll", () => {
        //         if (this.isAdding || this.pageInfo.end || this.searchMode) return;
        //         var scrollTop = con.scrollTop;
        //         if (con.scrollHeight - (scrollTop + con.offsetHeight) < 30) {
        //             this.isAdding = true;
        //             this.addWorks();
        //         }
        //     });
        // }
        observe = null;
        addScroller() {
            if (this.observe) return;
            let dom = this.$refs.scrollblock;
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e) => {
                    console.log(e);
                    if (e[0] && e[0].isIntersecting && !this.isAdding && !this.pageInfo.end && !this.searchMode) {
                        this.isAdding = true;
                        this.addWorks();
                    }
                });
                this.observe.observe(dom);
            }
        }

        addWorks() {
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let p = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: this.pageInfo.offset,
                count: this.pageInfo.count,
                platform: this.$store.state.publicStore.runPlatform,
            };
            this.$edApi
                .getStarList(p)
                .then((data) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    let list = data.data;
                    this.pageInfo.total = data.msg;
                    let arr = this.filesList;
                    if (list.length == 0) {
                        this.pageInfo.end = true;
                    } else {
                        this.pageInfo.offset += list.length;
                    }
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].info) {
                            let obj = {
                                id: list[i].info.id,
                                key: list[i].info.obj,
                                size: list[i].info.size,
                                updated_at: list[i].star_date,
                                info: list[i].info,
                                name: "",
                            };
                            if (this.isPrivate) {
                                obj.name = list[i].info.name;
                            } else {
                                let nameList = obj.key.split("/");
                                let name = nameList[nameList.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                obj.name = name;
                            }
                            arr.push(obj);
                        }
                    }
                    this.isAdding = false;
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }
        getStarList() {
            this.loadingStatus = true;
            this.filesList = [];
            this.$store.commit("setState", { data: true, type: "showLoading" });
            this.pageInfo.offset = 0;
            let p = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: this.pageInfo.offset,
                count: this.pageInfo.count,
            };
            this.$edApi
                .getStarList(p)
                .then((data) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    let list = data.data;
                    this.pageInfo.total = data.msg;
                    let arr = [];
                    this.pageInfo.offset += list.length;
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].info) {
                            let obj = {
                                id: list[i].info.id,
                                key: list[i].info.obj,
                                size: list[i].info.size,
                                updated_at: list[i].star_date,
                                info: list[i].info,
                                name: "",
                            };
                            if (this.isPrivate) {
                                obj.name = obj.info.name;
                            } else {
                                let nameList = obj.key.split("/");
                                let name = nameList[nameList.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                obj.name = name;
                            }
                            arr.push(obj);
                        }
                    }
                    // arr.sort((a, b) => {return new Date(b.opened_at).getTime() - new Date(a.opened_at).getTime()})
                    console.log(arr);
                    this.filesList = arr;
                    this.loadingStatus = false;
                    this.addScroller();
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.loadingStatus = false;
                });
        }

        setStarFile(file = null) {
            let done = () => {
                this.pageInfo.offset--;
                let path = "",
                    pathArr = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    if (this.activeList[i].info.id == tempId) {
                        pathArr = this.activeList[i].key.split("/");
                        this.activeList.splice(i, 1);
                        if (this.searchMode) {
                            const index = this.filesList.findIndex((item) => item.info.id === tempId);
                            ~index && this.filesList.splice(index, 1);
                        }
                        break;
                    }
                }
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                if (pathArr.length > 0) {
                    path = pathArr.join("/") + "/";
                }
                this.$bus.$emit("changeFileInfo", {
                    id: tempId,
                    key: "start_tag",
                    path,
                    value: 0,
                });
            };
            let tempId = -1;
            let type = 0;
            if (file) {
                type = file.info.start_tag ^ 1;
                tempId = file.info.id;
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: file.info.id,
                        file_key: file.info.file_key,
                    })
                    .then((res) => {
                        file.info.start_tag = type;
                        done();
                    });
            } else {
                type = this.selFiles[0].info.start_tag ^ 1;
                tempId = this.selFiles[0].info.id;
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: this.selFiles[0].info.id,
                        file_key: this.selFiles[0].info.file_key,
                    })
                    .then((res) => {
                        this.selFiles[0].info.start_tag = type;
                        done();
                    });
            }
        }
        loadErr(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        contextmenu(e, files, index) {}
        mounted() {
            window.addEventListener("message", this.receiveMessage, false);
        }
        beforeDestroy() {
            this.selectFilesIndex = [];
            this.contextmenuBoxShow = false;
            this.$bus.$off("refreshStar");
            this.$bus.$off("loginSucc-star");
            window.removeEventListener("message", this.receiveMessage);
            this.observe?.unobserve(this.$refs.scrollblock);
            this.observe = null;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "收藏文件",
    "name": "文件名",
    "time": "打开时间",
    "size": "文件大小",
    "openFile": "打开",
    "search": "搜索文件",
    "return": "返回",
    "notTem": "还没有收藏文件~",
    "notFind": "没有查到相应的收藏文件",
    "switchView": "切换视图",
    "personal": "个人云",
    "cancelStar": "取消收藏"
  },
  "en": {
    "title": "Starred File",
    "name": "File name",
    "time": "Open time",
    "size": "File size",
    "openFile": "Open",
    "search": "Search file",
    "return": "Return",
    "notTem": "No star file yet.",
    "notFind": "Not Find",
    "switchView": "Switch View",
    "personal": "Personal",
    "cancelStar": "Unstar"
  },
  "fr": {
    "title": "Fichier étoil",
    "name": "nom de fichier",
    "time": "Temps ouvert",
    "size": "Taille du fichier",
    "openFile": "allumer",
    "search": "Rechercher un fichier",
    "return": "retour",
    "notTem": "Pas encore de fichier étoile.",
    "notFind": "Aucun fichier  étoile correspondant trouvé",
    "switchView": "Changer de vue",
    "personal": "Cloud personnel",
    "cancelStar": "Annuler l'étoile"
  },
  "de": {
    "title": "Sternendatei",
    "name": "Dateiname",
    "time": "Öffnungszeit",
    "size": "Dateigröße",
    "openFile": "Anschalten",
    "search": "Datei durchsuchen",
    "return": "Rückkehr",
    "notTem": "Noch keine Sternendatei",
    "notFind": "Keinen entsprechenden Browsenverlauf gefunden",
    "switchView": "Ansicht wechseln",
    "personal": "Persönlicher Cloud",
    "cancelStar": "Unstar"
  },
  "jp": {
    "title": "スターファイル",
    "name": "ファイル名",
    "time": "時間",
    "size": "サイズ",
    "openFile": "開く",
    "search": "ファイルを検索",
    "return": "戻る",
    "notTem": "スターファイルはまだありません",
    "notFind": "該当するスターファイルが見つかりませんでした",
    "switchView": "ビューを切り替える",
    "personal": "個人クラウド",
    "cancelStar": "スターを外す"
  },
  "es": {
    "title": "Estrellas archivos",
    "name": "nombre del archivo",
    "time": "Tiempo abierto",
    "size": "Tamaño del archivo",
    "openFile": "encender",
    "search": "Archivo de búsqueda",
    "return": "regreso",
    "notTem": "No hay estrellas archivos.",
    "notFind": "No se encontró.",
    "switchView": "Cambiar vista",
    "personal": "Nube Personal",
    "cancelStar": "Unstar"
  },
  "pt": {
    "title": "Documentos estrelados",
    "name": "nome do arquivo",
    "time": "Tempo aberto",
    "size": "Tamanho do arquivo",
    "openFile": "Ligar",
    "search": "Pesquisar arquivo",
    "return": "Retorna",
    "notTem": "Ainda sem arquivos estrelados",
    "notFind": "Nenhum documento estrelado correspondente foi encontrado",
    "switchView": "Trocar Visualização",
    "personal": "Pessoal",
    "cancelStar": "Unstar"
  },
  "it": {
    "title": "File Stella",
    "name": "Nome del file",
    "time": "Tempo aperto",
    "size": "Dimensione del file",
    "openFile": "accendere",
    "search": "Cerca file",
    "return": "ritorno",
    "notTem": "Nessun file Stella ancora",
    "notFind": "Nessun file Stella corrispondente trovato",
    "switchView": "Cambia Vista",
    "personal": "Personali",
    "cancelStar": "Rimuovi da Speciali"
  },
  "tw": {
    "title": "星標檔案",
    "name": "檔案名",
    "time": "打開時間",
    "size": "檔案大小",
    "openFile": "打開",
    "search": "搜尋檔案",
    "return": "返回",
    "notTem": "還沒有星標檔案~",
    "notFind": "沒有查到相應的星標檔案",
    "switchView": "切換視圖",
    "personal": "個人雲端硬碟",
    "cancelStar": "取消星標"
  },
  "kr": {
    "title": "별표 파일",
    "name": "파일 이름",
    "time": "시간",
    "size": "파일 크기",
    "openFile": "파일 열기",
    "search": "파일 검색",
    "return": "돌아가기",
    "notTem": "아직 별표 파일이 없습니다~",
    "notFind": "해당 별표 파일을 찾을 수 없습니다",
    "switchView": "보기 전환",
    "personal": "개인 클라우드",
    "cancelStar": "별표 취소"
  },
  "id": {
    "title": "File Berbintang",
    "name": "Nama file",
    "time": "Buka waktu",
    "size": "Ukuran file",
    "openFile": "Buka",
    "search": "Cari file",
    "return": "Kembali",
    "notTem": "Belum ada file berbintang.",
    "notFind": "Tidak Menemukan",
    "switchView": "Ganti Tampilan",
    "personal": "Personal",
    "cancelStar": "Hapus bintang"
  }
}
</i18n>
